export default __webpack_public_path__ + "static/media/logo-horseshoes.5ce30599.svg";